





















































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import fetch from "@/common/api/fetch";

import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import { formatMoney } from '@/common/utils/format';
import { AxiosPromiseData } from "@/common/interface";

const RANKLIST_URL: {
  [index: string]: string
} = {
  'solitaireType': 'anon/solitaire/getAllApplySignIns',
  'bargainType': 'anon/bargain/getRankList',
  'tyType': `c/xm/show/ty/get/order/list`
}

@Component
export default class RankList extends Vue {
  @Getter("rankList") rankList!: Array<any>;
  @Getter("section") section!: any;
  @Getter("titleSection") titleSection!: any;
  @Action("changeRankList") changeRankList!: Function;

  hasNext: boolean = false;
  pageNo: Number = 0;
  pageSize: Number = 20;
  templateType: string = getActivityType();

  formatMoney: Function = formatMoney;

  mounted() {
    if (getUrlParam("type") === "share") {
      this.getRankList();
    }
  }

  getRankList() {
    if (this.templateType !== 'tyType') {
      const param = {
        activityId: getUrlParam("broadcastId"),
        pageNo: this.pageNo,
        pageSize:  this.pageSize
      };
      fetch.newpost(RANKLIST_URL[getActivityType()], param)
      .then((res: AxiosPromiseData) => {
        const { pages, records } = res.result;
        const rankList = this.rankList.concat(records);
        this.changeRankList(rankList);
        this.hasNext = this.pageNo < Number(pages) - 1;
      });
    } else {
      const param = {
        broadcastId: getUrlParam("broadcastId"),
        pageNo: this.pageNo,
        pageSize: 1000
      };
      fetch.post(RANKLIST_URL[getActivityType()], param)
      .then((res: AxiosPromiseData) => {
        const { data, totalCount } = res;
        this.changeRankList(data);
      });
    }
    
  }
  handleGetNext() {
    this.pageNo = Number(this.pageNo) + 1;
    this.getRankList();
  }
}
